<template>
  <div>
    <div v-if="env === 'uat'" class="env-banner">
      Environnement de test (UAT)
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      env: process.env.VUE_APP_ENV,
    };
  },
};
</script>

<style scoped>
.env-banner {
  background-color: yellow;
  color: #900;
  text-align: center;
  padding: 8px;
  font-weight: bold;
  margin-bottom: 16px;
}
</style>
